import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LocalCartItemType } from '@/types/cart'

type LocalCartStoreType = {
  items: LocalCartItemType[]
  hydrated: boolean
  addItem: (item: LocalCartItemType) => void
  updateItem: (productId: string, quantity: number) => void
  removeItem: (productId: string) => void
  clearItems: () => void
  totalQuantity: () => number
  setHydrated: (value: boolean) => void
}

const useLocalCartStore = create<LocalCartStoreType>()(
  persist(
    (set, get) => ({
      items: [],
      hydrated: false,
      setHydrated: (value: boolean) => set({ hydrated: value }),
      addItem: (newItem: LocalCartItemType) => {
        set(state => {
          const existing = state.items.find(i => i.productId === newItem.productId)
          if (existing) {
            return {
              items: state.items.map(i =>
                i.productId === newItem.productId
                  ? { ...i, quantity: Math.min(i.quantity + newItem.quantity, i.stock) }
                  : i
              )
            }
          }
          return { items: [...state.items, newItem] }
        })
      },
      updateItem: (productId: string, quantity: number) => {
        set(state => ({
          items: state.items.map(i => (i.productId === productId ? { ...i, quantity } : i))
        }))
      },
      removeItem: (productId: string) => {
        set(state => ({ items: state.items.filter(i => i.productId !== productId) }))
      },
      clearItems: () => set({ items: [] }),
      totalQuantity: () => get().items.reduce((acc, i) => acc + i.quantity, 0)
    }),
    {
      name: 'guest-cart',
      onRehydrateStorage: () => state => {
        state?.setHydrated(true)
      }
    }
  )
)

export default useLocalCartStore
